import React from "react";
import { Modal, Button, Row, Col, Table, Badge } from "react-bootstrap";
import { Invoice } from "../../../svgFiles/Invoice";
import "./billViewModal.css";
/* import { decrypt } from "../../../helpers/decrypt"; */
import CommonModal from "../modalLayout/CommonModal";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, formatNumber } from "../../../helpers/Utils";
import { DEFAULT_DATE_FORMAT } from "../../../helpers/constants";

const BillViewModal = ({ show, handleClose, billData, setShow }) => {
  const { _t } = useTranslator();
  if (!billData) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";    
    return convertToUserTimezone(dateString, DEFAULT_DATE_FORMAT);
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={`${_t("bill_details_title", "Bill Details")} #${
        billData.bill_number
      }`}
    >
      <div className="bill-details-container">
        {/* Status Badge */}
        <div className="text-end mb-3">
          {billData.status == "unpaid" ? (
            <span className="cursor-pointer cmn_badge rejected text-center">
              {_t(billData.status?.toUpperCase() , billData.status?.toUpperCase())}
            </span>
          ) : (
            <span className="cursor-pointer cmn_badge text-center">
              {_t(billData.status?.toUpperCase() , billData.status?.toUpperCase())}
            </span>
          )}
        </div>

        {/* Primary Bill Info */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="info-group">
              <h5>{_t("vendor_information", "Vendor Information")}</h5>
              <p>
                <strong>{_t("name", "Name")}:</strong> {billData.vendor_name}
              </p>
              <p>
                <strong>{_t("email", "Email")}:</strong> {billData.vendor_email}
              </p>
              <p>
                <strong>{_t("address", "Address")}:</strong>{" "}
                {billData.vendor_address}
              </p>
            </div>
          </Col>
          <Col md={6}>
            <div className="info-group">
              <h5>{_t("bill_information", "Bill Information")}</h5>
              <p>
                <strong>{_t("bill_date", "Bill Date")}:</strong>{" "}
                {convertToUserTimezone(billData.bill_date)}
              </p>
              <p>
                <strong>{_t("due_date", "Due Date")}:</strong>{" "}
                {convertToUserTimezone(billData.due_date)}
              </p>
              <p>
                <strong>{_t("total_amount", "Total Amount")}:</strong> $
                {formatNumber(billData.total_amount || 0)}
              </p>
            </div>
          </Col>
        </Row>

        {/* Expense Items */}
        <div className="expense-items mb-4">
          <h5>{_t("expense_items", "Expense Items")}</h5>
          <Table bordered hover responsive className="mt-2">
            <thead>
              <tr>
                <th>{_t("expense_type", "Expense Type")}</th>
                <th>{_t("description", "Description")}</th>
                <th className="text-end">{_t("amount", "Amount")}</th>
              </tr>
            </thead>
            <tbody>
              {billData.items && billData.items.length > 0 ? (
                billData.items.map((item) => (
                  <tr key={item.id}>
                    <td>{_t(item.expense_type ,item.expense_type)}</td>
                    <td>{item.description}</td>
                    <td className="text-end">
                      ${formatNumber(item.amount || 0)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    {_t("no_expense_items_found", "No expense items found")}
                  </td>
                </tr>
              )}
              <tr className="total-row">
                <td colSpan="2" className="text-end">
                  <strong>{_t("total", "Total")}</strong>
                </td>
                <td className="text-end">
                  <strong>${formatNumber(billData.total_amount || 0)}</strong>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        {/* Bank Information */}
        <div className="bank-details mb-4">
          <h5>{_t("bank_information", "Bank Information")}</h5>
          <Row>
            <Col md={6}>
              <p>
                <strong>{_t("account_holder", "Account Holder")}:</strong>{" "}
                {billData.bank_account_holder_name}
              </p>
              <p>
                <strong>{_t("bank_name", "Bank Name")}:</strong>{" "}
                {/* decrypt( */billData.bank_name/* ) */}
              </p>
            </Col>
            <Col md={6}>
              <p>
                <strong>{_t("account_number", "Account Number")}:</strong>{" "}
                {/* decrypt( */billData.bank_account_number/* ) */}
              </p>
              <p>
                <strong>{_t("rfc", "RFC")}:</strong> {billData.bank_rfc}
              </p>

              {billData.bank_concept ? (
                <p>
                  <strong>{_t("concept", "Concept")}:</strong>{" "}
                  {billData.bank_concept}
                </p>
              ) : (
                " "
              )}
            </Col>
          </Row>
        </div>

        {/* Description */}
        {billData.description && (
          <div className="description mb-4">
            <h5>{_t("description_heading", "Description")}</h5>
            <p>{billData.description}</p>
          </div>
        )}

        {/* Invoice */}
        {billData.invoice_file_url && (
          <div className="invoice-section text-center mt-4">
            <a
              href={billData.invoice_file_url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn invoice-btn"
            >
              <span>{Invoice}</span>
              {_t("view_invoice", "View Invoice")}
            </a>
          </div>
        )}
      </div>
      {/* </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal> */}
    </CommonModal>
  );
};

export default BillViewModal;
